import React from 'react';
import { BRAND } from '../config/branding';

function Terms() {
  return (
    <div style={{ minHeight: '100vh', padding: '40px 24px', background: '#f7f8fb' }}>
      <div style={{ maxWidth: '900px', margin: '0 auto', background: '#fff', borderRadius: '12px', boxShadow: '0 6px 18px rgba(0,0,0,0.08)', padding: '48px' }}>
        <h1 style={{ marginTop: 0, color: '#333', fontSize: '32px', marginBottom: '12px' }}>Terms of Service</h1>
        <p style={{ color: '#666', fontSize: '14px', marginBottom: '32px' }}>
          Last Updated: February 13, 2026
        </p>

        <div style={{ lineHeight: 1.8, color: '#333' }}>
          {/* Introduction */}
          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#333', fontSize: '24px', marginBottom: '16px' }}>1. Agreement to Terms</h2>
            <p>
              Welcome to {BRAND.name}, proprietary software owned by {BRAND.short} - International Council for Standards & Certification.
              By accessing or using {BRAND.name}, you agree to be bound by these
              Terms of Service ("Terms"). If you do not agree to these Terms, you may not use the platform.
            </p>
            <p>
              These Terms constitute a legally binding agreement between you (the "User") and
              {BRAND.short} - International Council for Standards & Certification ("we," "us," or "our").
            </p>
          </section>

          {/* Definitions */}
          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#333', fontSize: '24px', marginBottom: '16px' }}>2. Definitions</h2>
            <ul style={{ marginLeft: '24px' }}>
              <li><strong>"Platform"</strong> refers to the {BRAND.name} software application and services</li>
              <li><strong>"User"</strong> includes Client users, Certification Body Admins, and Super Admins</li>
              <li><strong>"Content"</strong> means data, documents, and information uploaded or created in the Platform</li>
              <li><strong>"Services"</strong> refers to ISO implementation management and certification tracking features</li>
            </ul>
          </section>

          {/* Eligibility */}
          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#333', fontSize: '24px', marginBottom: '16px' }}>3. Eligibility</h2>
            <p>To use {BRAND.name}, you must:</p>
            <ul style={{ marginLeft: '24px' }}>
              <li>Be at least 18 years of age</li>
              <li>Have the authority to bind your organization to these Terms</li>
              <li>Provide accurate and complete registration information</li>
              <li>Not be prohibited from using the Services under applicable laws</li>
            </ul>
          </section>

          {/* Account Responsibilities */}
          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#333', fontSize: '24px', marginBottom: '16px' }}>4. User Accounts and Security</h2>
            
            <h3 style={{ color: '#555', fontSize: '18px', marginTop: '20px', marginBottom: '12px' }}>4.1 Account Registration</h3>
            <p>When creating an account, you agree to:</p>
            <ul style={{ marginLeft: '24px' }}>
              <li>Provide accurate, current, and complete information</li>
              <li>Maintain and update your account information</li>
              <li>Create a strong password meeting our security requirements</li>
              <li>Keep your login credentials confidential</li>
            </ul>

            <h3 style={{ color: '#555', fontSize: '18px', marginTop: '20px', marginBottom: '12px' }}>4.2 Account Security</h3>
            <p>You are responsible for:</p>
            <ul style={{ marginLeft: '24px' }}>
              <li>All activities conducted under your account</li>
              <li>Maintaining the confidentiality of your password</li>
              <li>Immediately notifying us of unauthorized access</li>
              <li>Ensuring compliance with our password policies</li>
            </ul>

            <h3 style={{ color: '#555', fontSize: '18px', marginTop: '20px', marginBottom: '12px' }}>4.3 Account Termination</h3>
            <p>You may:</p>
            <ul style={{ marginLeft: '24px' }}>
              <li>Deactivate your account at any time via Profile settings</li>
              <li>Request permanent deletion of your account (Right to be Forgotten)</li>
              <li>Export your data before deletion</li>
            </ul>
            <p>We may suspend or terminate accounts for violations of these Terms.</p>
          </section>

          {/* Acceptable Use */}
          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#333', fontSize: '24px', marginBottom: '16px' }}>5. Acceptable Use Policy</h2>
            
            <h3 style={{ color: '#555', fontSize: '18px', marginTop: '20px', marginBottom: '12px' }}>5.1 Permitted Use</h3>
            <p>You may use {BRAND.name} to:</p>
            <ul style={{ marginLeft: '24px' }}>
              <li>Manage ISO standard implementation for your organization</li>
              <li>Track certification progress and requirements</li>
              <li>Generate compliance reports and documentation</li>
              <li>Collaborate with certification bodies (where applicable)</li>
            </ul>

            <h3 style={{ color: '#555', fontSize: '18px', marginTop: '20px', marginBottom: '12px' }}>5.2 Prohibited Activities</h3>
            <p>You agree NOT to:</p>
            <ul style={{ marginLeft: '24px' }}>
              <li>Violate any laws or regulations</li>
              <li>Infringe intellectual property rights</li>
              <li>Upload malicious code, viruses, or malware</li>
              <li>Attempt to gain unauthorized access to systems or data</li>
              <li>Reverse engineer, decompile, or disassemble the Platform</li>
              <li>Use automated tools to scrape or harvest data</li>
              <li>Share your account credentials with unauthorized parties</li>
              <li>Interfere with or disrupt the Platform's operation</li>
              <li>Impersonate another user or entity</li>
              <li>Upload false, misleading, or fraudulent information</li>
            </ul>
          </section>

          {/* Intellectual Property */}
          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#333', fontSize: '24px', marginBottom: '16px' }}>6. Intellectual Property Rights</h2>
            
            <h3 style={{ color: '#555', fontSize: '18px', marginTop: '20px', marginBottom: '12px' }}>6.1 Platform Ownership</h3>
            <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px', border: '2px solid #667eea' }}>
              <p style={{ margin: 0, fontWeight: '600', color: '#333' }}>
                {BRAND.name} is proprietary software owned exclusively by {BRAND.short} - International Council for Standards & Certification.
                All rights reserved.
              </p>
            </div>
            <p style={{ marginTop: '16px' }}>
              The Platform, including its code, design, features, branding, and documentation, is protected by
              copyright, trademark, and other intellectual property laws. No license or right is granted except
              as explicitly stated in these Terms.
            </p>

            <h3 style={{ color: '#555', fontSize: '18px', marginTop: '20px', marginBottom: '12px' }}>6.2 Your Content</h3>
            <p>You retain ownership of Content you upload to {BRAND.name}. By uploading Content, you grant us:</p>
            <ul style={{ marginLeft: '24px' }}>
              <li>A non-exclusive license to store, process, and display your Content to provide the Services</li>
              <li>The right to backup and secure your Content</li>
              <li>Permission to share Content within your organizational hierarchy (as per access controls)</li>
            </ul>
            <p>You represent that you have the right to upload and share your Content.</p>
          </section>

          {/* Service Availability */}
          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#333', fontSize: '24px', marginBottom: '16px' }}>7. Service Availability and Modifications</h2>
            
            <h3 style={{ color: '#555', fontSize: '18px', marginTop: '20px', marginBottom: '12px' }}>7.1 Availability</h3>
            <p>
              We strive to maintain 99.9% uptime but do not guarantee uninterrupted access. The Platform may be 
              unavailable due to maintenance, updates, or circumstances beyond our control.
            </p>

            <h3 style={{ color: '#555', fontSize: '18px', marginTop: '20px', marginBottom: '12px' }}>7.2 Modifications</h3>
            <p>We reserve the right to:</p>
            <ul style={{ marginLeft: '24px' }}>
              <li>Modify, update, or discontinue features with notice</li>
              <li>Change pricing or subscription terms (with advance notice)</li>
              <li>Update these Terms (material changes require user consent)</li>
            </ul>
          </section>

          {/* Data and Privacy */}
          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#333', fontSize: '24px', marginBottom: '16px' }}>8. Data Protection and Privacy</h2>
            <p>
              Your use of {BRAND.name} is subject to our <a href="/privacy" style={{ color: '#667eea', textDecoration: 'none', fontWeight: '500' }}>Privacy Policy</a>,
              which explains how we collect, use, and protect your personal data in compliance with GDPR and other
              data protection laws.
            </p>

            <h3 style={{ color: '#555', fontSize: '18px', marginTop: '20px', marginBottom: '12px' }}>8.1 Cookie Consent</h3>
            <p>
              When you first visit {BRAND.name}, you will be presented with a cookie consent banner. You can choose to:
            </p>
            <ul style={{ marginLeft: '24px' }}>
              <li>Accept all cookies (essential, analytics, and functional)</li>
              <li>Accept essential cookies only</li>
              <li>Customize your preferences for each cookie category</li>
            </ul>
            <p>
              Your cookie preferences are stored locally and can be updated at any time. Essential cookies cannot be disabled
              as they are necessary for authentication and platform functionality.
            </p>

            <h3 style={{ color: '#555', fontSize: '18px', marginTop: '20px', marginBottom: '12px' }}>8.2 GDPR Rights and Self-Service Tools</h3>
            <p>You have the following rights under GDPR, which you can exercise via self-service tools:</p>
            <ul style={{ marginLeft: '24px' }}>
              <li><strong>Right of Access (Article 15):</strong> Export all your data in JSON format via <code>/users/gdpr/export-data</code></li>
              <li><strong>Right to Erasure (Article 17):</strong> Request permanent account deletion via <code>/users/gdpr/request-erasure</code></li>
              <li><strong>Right to Rectification:</strong> Update your profile information at any time</li>
              <li><strong>Data Retention Transparency:</strong> View retention policies via <code>/users/gdpr/data-retention-status</code></li>
            </ul>

            <h3 style={{ color: '#555', fontSize: '18px', marginTop: '20px', marginBottom: '12px' }}>8.3 Data Retention and Deletion</h3>
            <p>We retain data according to the schedules outlined in our Privacy Policy. Key points:</p>
            <ul style={{ marginLeft: '24px' }}>
              <li><strong>Account Deletion Grace Period:</strong> When you request account deletion, a 30-day grace period begins. You can cancel the deletion request during this time.</li>
              <li><strong>Legal Holds:</strong> Some data cannot be deleted immediately due to legal obligations (e.g., financial records must be retained for 7 years under tax law).</li>
              <li><strong>Anonymization:</strong> Data that must be retained for legal compliance is anonymized to remove personal identifiers where possible.</li>
            </ul>

            <h3 style={{ color: '#555', fontSize: '18px', marginTop: '20px', marginBottom: '12px' }}>8.4 Security Commitments</h3>
            <p>Key commitments regarding data security:</p>
            <ul style={{ marginLeft: '24px' }}>
              <li>We implement industry-standard security measures (encryption, bcrypt password hashing, JWT authentication)</li>
              <li>You can export or delete your data at any time using self-service tools</li>
              <li>We maintain comprehensive audit logs for security and compliance monitoring</li>
              <li>Your data is never sold to third parties</li>
              <li>All administrative actions are logged and can be audited</li>
            </ul>
          </section>

          {/* Disclaimer of Warranties */}
          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#333', fontSize: '24px', marginBottom: '16px' }}>9. Disclaimer of Warranties</h2>
            <div style={{ background: '#fff3cd', padding: '20px', borderRadius: '8px', border: '1px solid #ffc107' }}>
              <p style={{ margin: 0, color: '#856404' }}>
                <strong>THE PLATFORM IS PROVIDED "AS IS" AND "AS AVAILABLE" WITHOUT WARRANTIES OF ANY KIND.</strong>
              </p>
            </div>
            <p style={{ marginTop: '16px' }}>
              To the fullest extent permitted by law, we disclaim all warranties, express or implied, including:
            </p>
            <ul style={{ marginLeft: '24px' }}>
              <li>Warranties of merchantability, fitness for a particular purpose, or non-infringement</li>
              <li>Guarantees of accuracy, completeness, or reliability of Content</li>
              <li>Assurances that the Platform will be error-free or uninterrupted</li>
              <li>Warranties regarding ISO certification outcomes or regulatory compliance</li>
            </ul>
            <p style={{ marginTop: '16px', fontStyle: 'italic', color: '#666' }}>
              Note: {BRAND.name} is a management tool. Achieving ISO certification depends on your organization's 
              implementation and third-party audit processes, not solely on platform usage.
            </p>
          </section>

          {/* Limitation of Liability */}
          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#333', fontSize: '24px', marginBottom: '16px' }}>10. Limitation of Liability</h2>
            <p>
              <strong>TO THE MAXIMUM EXTENT PERMITTED BY LAW, ICSC - INTERNATIONAL COUNCIL FOR STANDARDS & CERTIFICATION AND ITS AFFILIATES
              SHALL NOT BE LIABLE FOR:</strong>
            </p>
            <ul style={{ marginLeft: '24px' }}>
              <li>Indirect, incidental, special, consequential, or punitive damages</li>
              <li>Loss of profits, revenue, data, or business opportunities</li>
              <li>Service interruptions or data loss</li>
              <li>Third-party actions or Content</li>
              <li>Failure to achieve ISO certification</li>
            </ul>
            <p style={{ marginTop: '16px' }}>
              <strong>Our total liability shall not exceed the fees paid by you (if any) in the 12 months
              preceding the claim, or £100, whichever is greater.</strong>
            </p>
          </section>

          {/* Indemnification */}
          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#333', fontSize: '24px', marginBottom: '16px' }}>11. Indemnification</h2>
            <p>You agree to indemnify and hold harmless ICSC - International Council for Standards & Certification from any claims arising from:</p>
            <ul style={{ marginLeft: '24px' }}>
              <li>Your violation of these Terms</li>
              <li>Your infringement of third-party rights</li>
              <li>Your Content uploaded to the Platform</li>
              <li>Your unauthorized use of the Services</li>
            </ul>
          </section>

          {/* Termination */}
          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#333', fontSize: '24px', marginBottom: '16px' }}>12. Termination</h2>
            
            <h3 style={{ color: '#555', fontSize: '18px', marginTop: '20px', marginBottom: '12px' }}>12.1 By You</h3>
            <p>You may terminate your account at any time by:</p>
            <ul style={{ marginLeft: '24px' }}>
              <li>Deactivating via Profile settings (data preserved for reactivation)</li>
              <li>Requesting permanent deletion via Profile → "Request Data Erasure" (GDPR Right to be Forgotten)</li>
            </ul>
            <p style={{ background: '#fff3cd', padding: '12px', borderRadius: '6px', border: '1px solid #ffc107', marginTop: '12px' }}>
              <strong>Grace Period:</strong> When you request permanent deletion, a 30-day grace period begins.
              During this time, you can cancel the deletion request. After 30 days, your personal data is permanently deleted,
              subject to legal retention requirements.
            </p>

            <h3 style={{ color: '#555', fontSize: '18px', marginTop: '20px', marginBottom: '12px' }}>12.2 By Us</h3>
            <p>We may suspend or terminate your account if:</p>
            <ul style={{ marginLeft: '24px' }}>
              <li>You violate these Terms</li>
              <li>Your account is inactive for an extended period</li>
              <li>Required by law or regulation</li>
              <li>We discontinue the Platform (with advance notice)</li>
            </ul>

            <h3 style={{ color: '#555', fontSize: '18px', marginTop: '20px', marginBottom: '12px' }}>12.3 Effect of Termination</h3>
            <p>Upon termination:</p>
            <ul style={{ marginLeft: '24px' }}>
              <li>Your access to the Platform will cease immediately</li>
              <li>Export your data before deletion (if applicable)</li>
              <li>Provisions that should survive (liability, indemnification) remain in effect</li>
            </ul>
          </section>

          {/* Governing Law */}
          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#333', fontSize: '24px', marginBottom: '16px' }}>13. Governing Law and Jurisdiction</h2>
            <p>
              These Terms are governed by the laws of [Your Jurisdiction], without regard to conflict of law principles. 
              Any disputes shall be resolved exclusively in the courts of [Your Jurisdiction].
            </p>
          </section>

          {/* Dispute Resolution */}
          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#333', fontSize: '24px', marginBottom: '16px' }}>14. Dispute Resolution</h2>
            <p>Before initiating legal proceedings, parties agree to:</p>
            <ol style={{ marginLeft: '24px' }}>
              <li>Notify the other party in writing of the dispute</li>
              <li>Attempt to resolve the dispute through good faith negotiations for 30 days</li>
              <li>Consider mediation if negotiations fail</li>
            </ol>
          </section>

          {/* Miscellaneous */}
          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#333', fontSize: '24px', marginBottom: '16px' }}>15. Miscellaneous</h2>
            
            <h3 style={{ color: '#555', fontSize: '18px', marginTop: '20px', marginBottom: '12px' }}>15.1 Entire Agreement</h3>
            <p>These Terms, together with our Privacy Policy, constitute the entire agreement between you and us.</p>

            <h3 style={{ color: '#555', fontSize: '18px', marginTop: '20px', marginBottom: '12px' }}>15.2 Severability</h3>
            <p>If any provision is found invalid, the remaining provisions continue in effect.</p>

            <h3 style={{ color: '#555', fontSize: '18px', marginTop: '20px', marginBottom: '12px' }}>15.3 Waiver</h3>
            <p>Failure to enforce any right does not waive that right.</p>

            <h3 style={{ color: '#555', fontSize: '18px', marginTop: '20px', marginBottom: '12px' }}>15.4 Assignment</h3>
            <p>You may not assign these Terms. We may assign our rights to affiliates or successors.</p>

            <h3 style={{ color: '#555', fontSize: '18px', marginTop: '20px', marginBottom: '12px' }}>15.5 Force Majeure</h3>
            <p>We are not liable for delays or failures due to circumstances beyond our reasonable control.</p>
          </section>

          {/* Contact */}
          <section style={{ marginBottom: '32px' }}>
            <h2 style={{ color: '#333', fontSize: '24px', marginBottom: '16px' }}>16. Contact Information</h2>
            <p>For questions about these Terms, contact:</p>
            <div style={{ background: '#f8f9fa', padding: '20px', borderRadius: '8px', marginTop: '16px' }}>
              <p style={{ margin: 0, marginBottom: '8px' }}><strong>Legal Department</strong></p>
              <p style={{ margin: 0, marginBottom: '4px' }}>ICSC - International Council for Standards & Certification</p>
              <p style={{ margin: 0, marginBottom: '4px' }}>Email: legal@councilforstandards.org</p>
              <p style={{ margin: 0, marginBottom: '4px' }}>Website: councilforstandards.org</p>
            </div>
          </section>

          {/* Acknowledgment */}
          <section style={{ marginBottom: '0' }}>
            <div style={{ background: '#e3f2fd', padding: '20px', borderRadius: '8px', border: '1px solid #1565c0' }}>
              <p style={{ margin: 0, color: '#0d47a1', fontSize: '14px' }}>
                <strong>BY USING {BRAND.name.toUpperCase()}, YOU ACKNOWLEDGE THAT YOU HAVE READ, UNDERSTOOD, AND AGREE TO BE BOUND 
                BY THESE TERMS OF SERVICE.</strong>
              </p>
            </div>
          </section>
        </div>

        <div style={{ marginTop: '40px', paddingTop: '24px', borderTop: '1px solid #e9ecef' }}>
          <button
            onClick={() => window.history.back()}
            style={{ padding: '12px 24px', border: 'none', borderRadius: '6px', background: '#667eea', color: '#fff', cursor: 'pointer', fontSize: '14px', fontWeight: '500' }}
          >
            ← Go Back
          </button>
        </div>
      </div>
    </div>
  );
}

export default Terms;
